<script setup lang="ts">
const description = 'Validador de firmas digitales y documentos electrónicos. Verifica la validez de tus firmas digitales y documentos electrónicos de forma rápida y sencilla.'

useSeoMeta({
  titleTemplate: (titleChunk) => titleChunk ? `${titleChunk} | Signt` : 'Signt',
  description,
  ogDescription: description
})

</script>
<template>
  <UApp>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

  </UApp>
</template>

<style>
</style>
